import {InternalAxiosRequestConfig} from "axios";
import {useAuth} from "./useAuth"
import axiosClientNet from "../newApi/axiosClientNet";
import {useEffect} from "react";

export const useAxiosInterceptor = () => {
    const {token} = useAuth();

    useEffect(() => {
        const reqResInterceptor = (config: InternalAxiosRequestConfig) => {
            if (token && import.meta.env.VITE_BACKEND_TYPE === "dotnet")
                config.headers.Authorization = `Bearer ${token}`;
            return config;
        }
        const interceptorId = axiosClientNet.interceptors.request.use(reqResInterceptor);
        return () => {
            axiosClientNet.interceptors.request.eject(interceptorId);
        }
    }, [token]);
}